module.exports = __webpack_public_path__ + "static/network.514d50f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Storitve/images/network.svg
// module id = 785
// module chunks = 35783957827783